export const baseURL = "https://api.alfurqaninternational.org/api/v2";
//export const baseURL = "http://localhost:3001/api/v2";
